import React from 'react';
import { Button } from '../ui/button';
import { Download, Upload, Trash2, Printer } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { exportToJson, importFromJson, removeDuplicates, printContent } from '../../utils/adminUtils';

/**
 * Reusable Export/Import/Dedup buttons component
 */
export function ExportImportButtons({ 
  data, 
  exportFilename, 
  titleField, 
  idField, 
  apiEndpoint, 
  api,
  fetchCallback, 
  dataTransform = null,
  fieldsToExport = null,
  showDedup = true 
}) {
  const { language } = useLanguage();

  const handleExport = () => {
    exportToJson(data, exportFilename, language, fieldsToExport);
  };

  const handleImport = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (file) {
        await importFromJson(file, data, titleField, api, apiEndpoint, language, dataTransform);
        fetchCallback();
      }
    };
    input.click();
  };

  const handleRemoveDuplicates = async () => {
    await removeDuplicates(data, titleField, idField, api, apiEndpoint, language, fetchCallback);
  };

  return (
    <div className="flex gap-2 flex-wrap">
      <Button 
        variant="outline" 
        size="sm"
        onClick={handleExport}
      >
        <Download className="h-4 w-4 mr-2" />
        {language === 'fr' ? 'Exporter' : 'Export'}
      </Button>
      <Button 
        variant="outline"
        size="sm"
        onClick={handleImport}
      >
        <Upload className="h-4 w-4 mr-2" />
        {language === 'fr' ? 'Importer' : 'Import'}
      </Button>
      {showDedup && (
        <Button 
          variant="outline"
          size="sm"
          className="text-orange-600 border-orange-300 hover:bg-orange-50"
          onClick={handleRemoveDuplicates}
        >
          <Trash2 className="h-4 w-4 mr-2" />
          {language === 'fr' ? 'Suppr. doublons' : 'Remove duplicates'}
        </Button>
      )}
    </div>
  );
}

/**
 * Print button component
 */
export function PrintButton({ title, content, additionalInfo = '' }) {
  const { language } = useLanguage();

  const handlePrint = () => {
    printContent(title, content, additionalInfo);
  };

  return (
    <Button 
      variant="outline" 
      size="sm"
      onClick={handlePrint}
    >
      <Printer className="h-4 w-4 mr-2" />
      {language === 'fr' ? 'Imprimer' : 'Print'}
    </Button>
  );
}

export default ExportImportButtons;
